<div class="modal modal-filter-chips">
  <ion-button class="button transparent close-modal" [ngClass]="font?.size" (click)="closeModal()">
    <ion-icon class="icon" name="close"></ion-icon>
  </ion-button>
  <div class="content-filter-container">
    <div class="title" [ngClass]="font?.size" [innerHTML]="title | translate"></div>
    <app-filter-chips [elements]="filters" (selectedId)="goToSection($event)"></app-filter-chips>
  </div>
  <ion-button class="button primary back" [ngClass]="font?.size" (click)="closeModal()">{{ backButton | translate}}</ion-button>
</div>
